import { useGSAP } from "@gsap/react";
import clsx from "clsx";
import gsap from "gsap";
import {
  Children,
  useRef,
  type HTMLAttributes,
  type ReactNode,
  type RefObject,
} from "react";

interface VerticalSliderProps extends HTMLAttributes<HTMLDivElement> {
  direction?: 1 | -1;
  duration?: number;
}

const VerticalSlider = ({
  direction = 1,
  children,
  className,
  duration = 20,
}: VerticalSliderProps) => {
  const items = Children.toArray(children);
  const slideRef = useRef<HTMLDivElement | null>(null);
  const slide2Ref = useRef<HTMLDivElement | null>(null);
  useGSAP(
    () => {
      const slideEl = slideRef.current;
      const slide2El = slide2Ref.current;
      if (!slideEl || !slide2El) return;
      const height = slideEl.scrollHeight;
      gsap.set([slideEl, slide2El], {
        y: direction === 1 ? 0 : -height,
      });
      gsap.to([slideEl, slide2El], {
        y: direction === 1 ? -height : 0,
        duration: duration,
        ease: "none",
        repeat: -1,
      });
    },
    { dependencies: [direction, slideRef, slide2Ref] },
  );
  return (
    <div
      className={clsx(
        "w-full h-full flex flex-col overflow-hidden max-h-full",
        className,
      )}
    >
      <Slide items={items} ref={slideRef} slideNumber={1} />
      <Slide items={items} ref={slide2Ref} slideNumber={2} />
    </div>
  );
};

export default VerticalSlider;
const Slide = ({
  slideNumber,
  ref,
  items,
}: {
  slideNumber: number;
  ref: RefObject<HTMLDivElement | null>;
  items: ReactNode[];
}) => {
  return (
    <div
      ref={ref}
      className="flex flex-col min-h-fit w-full h-full justify-evenly items-center gap-3 py-1.5"
    >
      {items.map((item, indx) => (
        <div key={`slide-${slideNumber}-indx-${indx}`} className="w-full h-full">{item}</div>
      ))}{" "}
    </div>
  );
};
